import { getUrlParams, canOpenSafariViaScheme } from '@/utils/base';
import { intersection, isNaN } from 'lodash-es';

let conterInfo = {};

/** URL checkPhone：true / 1 为 true，其余为 false */
const parseCheckPhoneUrlParam = value => {
  if (value == null || value === '') {
    return false;
  }
  const s = String(value).toLowerCase();
  return s === 'true' || s === '1';
};

/**
 * 初始化收银台信息
 */
export const counterInfoInit = () => {
  try {
    // 获取url参数
    const urlParams = getUrlParams();

    // 必需有的参数
    const requiredKeys = ['mchId', 'sourceMemberId', 'accessToken', 'randomKey', 'walletMemberId'];

    const { accessToken } = urlParams;

    // 如果不是入口页面 则从本地缓存中获取
    if (!accessToken) {
      try {
        const counterInfoStr = localStorage.getItem('counterInfo');
        const values = counterInfoStr ? JSON.parse(counterInfoStr) : null;

        if (values && intersection(requiredKeys, Object.keys(values)).length === requiredKeys.length) {
          conterInfo = values;

          // 设置body的fullScreen
          if (values.isFullScreen) {
            document.body.className = 'fullScreen';
          }

          return '';
        }
      } catch (storageError) {
        console.warn('localStorage access failed:', storageError);
        return '存储访问失败，请重新访问';
      }

      return '访问过期，请重新访问';
    }

    // 如果url参数中包含必需的参数，则设置counterInfo
    if (intersection(requiredKeys, Object.keys(urlParams)).length === requiredKeys.length) {
      const { mchId, sourceMemberId, accessToken, randomKey, walletMemberId, jumpType, plat, bh, iosApp, payLevel, schemeOpen, checkPhone } = urlParams;

      // 是否全屏
      let isFullScreen = 0;
      if (!isNaN(Number(bh)) && Number(bh)) {
        isFullScreen = 1;
      }

      conterInfo = {
        mchId: Number(mchId),
        sourceMemberId,
        accessToken,
        randomKey,
        walletMemberId: Number(walletMemberId),
        isFullScreen,
        iosApp,
        schemeOpen: schemeOpen === '1' && canOpenSafariViaScheme(),
        checkPhone: parseCheckPhoneUrlParam(checkPhone),
      };

      // 跳转类型
      if (jumpType && !isNaN(Number(jumpType))) {
        conterInfo.jumpType = Number(jumpType);
      }

      // 平台
      if (plat && !isNaN(Number(plat))) {
        conterInfo.plat = Number(plat);
      }

      // 支付等级
      if (payLevel && !isNaN(Number(payLevel))) {
        conterInfo.payLevel = Number(payLevel);
      }

      // 页面类型
      conterInfo.pageType = location.pathname.includes('/counter/deposit') ? 'deposit' : 'withdrawal';

      // 数据记录到本地
      try {
        localStorage.setItem('counterInfo', JSON.stringify(conterInfo));
      } catch (storageError) {
        console.warn('Failed to save to localStorage:', storageError);
      }

      // 设置body的fullScreen
      if (isFullScreen) {
        document.body.className = 'fullScreen';
      }

      return '';
    }

    // 如果url参数中不包含必需的参数，则返回false
    return '访问错误';
  } catch (error) {
    console.error('counterInfoInit error:', error);
    return '初始化失败，请重新访问';
  }
};

/**
 * 获取收银台信息
 */
export const counterInfoGet = () => {
  return conterInfo;
};

/** 钱包域内请求收银台 /api 前注入会话（弹窗无收银台 localStorage） */
export const counterInfoBootstrapSeed = partial => {
  if (!partial || typeof partial !== 'object') return;
  const next = { ...conterInfo };
  if (partial.accessToken != null && partial.accessToken !== '') next.accessToken = partial.accessToken;
  if (partial.mchId != null && partial.mchId !== '') next.mchId = Number(partial.mchId);
  if (partial.sourceMemberId != null && partial.sourceMemberId !== '') next.sourceMemberId = partial.sourceMemberId;
  if (partial.walletMemberId != null && partial.walletMemberId !== '') next.walletMemberId = Number(partial.walletMemberId);
  if (partial.randomKey != null && partial.randomKey !== '') next.randomKey = partial.randomKey;
  if (partial.plat != null && partial.plat !== '') next.plat = Number(partial.plat);
  if (partial.isFullScreen != null && partial.isFullScreen !== '') next.isFullScreen = Number(partial.isFullScreen);
  conterInfo = next;
};

let noticeNum = 0;

/**
 * 读写通知个数
 */
export const rcNoticeNum = value => {
  if (value !== undefined) {
    noticeNum += value;
  }
  return noticeNum;
};

// 存款订单总数
let depositCount = 0;

// 取款订单总数
let processingPOrder = 0;

// 取款订单总数
let receivingPayCount = 0;

// 待处理订单总数（ >0 表示有待付款的单子，响铃 ，=0 不响铃）
let pendingPayCount = 0;

/**
 * 读写存款订单总数
 */
export const orderCountRC = value => {
  if (value !== undefined) {
    depositCount = value.depositCount;
    processingPOrder = value.processingPOrder;
    receivingPayCount = value.receivingPayCount;
    pendingPayCount = value.pendingPayCount;
  }
  return { depositCount, processingPOrder, receivingPayCount, pendingPayCount };
};

/**
 * 下载地址（68 场景等历史用法）
 */
export const download68AppURL = import.meta.env.VITE_DOWNLOAD_68_APP_URL;

/**
 * C 币通道无 downloadInfo.url 时的回落下载页（45）
 */
export const download45AppURL = import.meta.env.VITE_DOWNLOAD_45_APP_URL;

/** 59 聊天下载落地页（默认列表 / 45 配置下追加） */
export const download59AppURL = import.meta.env.VITE_DOWNLOAD_59_APP_URL;

// 余额的读写
let balance = null;

/**
 * 余额的读写
 */
export const counterBalanceRC = value => {
  if (value !== undefined) {
    balance = value;

    localStorage.setItem('balance', value);
  } else if (balance === null) {
    balance = localStorage.getItem('balance');
    return balance;
  } else {
    return balance;
  }

  return null;
};
